import React, { useEffect, useState } from "react";

interface PaginationProps {
    total: number;
    currentPage: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
                                                   total,
                                                   currentPage,
                                                   pageSize,
                                                   onPageChange,
                                                   onPageSizeChange,
                                               }) => {
    const totalPages = Math.ceil(total / pageSize);
    const [ page, setPage ] = useState(currentPage);
    const [ size, setSize ] = useState(pageSize.toString());

    useEffect(() => {
        if (currentPage > totalPages) {
            setPage(1);
            onPageChange(1);
        }
    }, [ totalPages, currentPage, onPageChange ]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= totalPages) {
            setPage(page);
            onPageChange(page);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value, 10);
        if (!isNaN(value)) {
            setPage(value);
        }
    };

    const handleInputBlur = () => {
        if (page > 0 && page <= totalPages) {
            onPageChange(page);
        } else {
            setPage(currentPage);
        }
    };

    const handlePageSizeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSize(e.target.value);
    };

    const handlePageSizeBlur = () => {
        const value = parseInt(size, 10);
        if (!isNaN(value) && value > 0) {
            onPageSizeChange(value);
        } else {
            setSize(pageSize.toString());
        }
    };

    const handlePageSizeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            handlePageSizeBlur();
        }
    };

    return (
        <div className="pagination">
            {/*
    'flex flex-nowrap items-center justify-center gap-2
     overflow-x-auto whitespace-nowrap mt-4'
    This ensures a single horizontal row with scroll if needed.
  */}
            <div className="flex flex-nowrap items-center justify-center gap-2 overflow-x-auto whitespace-nowrap mt-4">
                {/* Previous Button */}
                <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page === 1}
                >
                    Previous
                </button>

                {/* Current Page Input */}
                <input
                    type="number"
                    value={page}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    min={1}
                    max={totalPages}
                />

                {/* Total Pages */}
                <span>of {totalPages}</span>

                {/* Next Button */}
                <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page === totalPages}
                >
                    Next
                </button>

                {/* Page Size Input */}
                <input
                    type="text"
                    value={size}
                    onChange={handlePageSizeChange}
                    onBlur={handlePageSizeBlur}
                    onKeyDown={handlePageSizeKeyDown}
                />
                <span>items per page</span>
            </div>
        </div>
    );
};

export default Pagination;
